module.exports = __webpack_public_path__ + "static/media/app.8181b914.svg";